<template>
  <Container
    class="drag-container"
    :group-name="groupName"
    @drop="onDrop"
    :drag-class="dragClass"
    :should-accept-drop="getShouldAcceptDrop"
    :get-child-payload="getChildPayload"
    :non-drag-area-selector="nonDragAreaSelector"
    :drop-placeholder="dropPlaceholderOptions"
    :remove-on-drop-out="shouldRemoveOnDrop"
    :tag="tag"
    :lock-axis="lockAxis"
    :orientation="orientation"
    :behaviour="behaviour"
  >
    <slot/>
  </Container>
</template>
<script>
import { Container } from "vue-smooth-dnd";
export default {
  props: {
    groupName: {
      type: String,
      required: true
    },
    // Apply class to item on drag
    dragClass: {
      type: String
    },
    // Remove item from parent after it is dropped
    shouldRemoveOnDrop: {
      type: Boolean,
      default: false
    },
    // Collection of items within container.
    // Needed to get child payload
    collection: {
      type: Array,
      required: true
    },
    collectionByTab: {
      type: Array
    },
    collectionDrag: {
      type: Array
    },
    showTabs: {
      type: Boolean,
      default: false
    },
    nonDragAreaSelector: {
      type: String
    },
    dropPlaceholderOptions: {
      type: Object,
      default: () => ({
        className: 'drag-ghost'
      })
    },
    // If anything is droppable here
    shouldAcceptDrops: {
      type: Boolean,
      default: true
    },
    behaviour: {
      type: String
    },
    lockAxis: {
      type: String
    },
    tag: {
      type: Object
    },
    orientation: {
      type: String
    }
  },
  components: {
    Container
  },
  // these are all methods provided by the dnd library
  methods: {
    getChildPayload(index) {
      let payload = {}
      // the index provided by the dnd library is casted on the collection by tab if we are in tabs
      // thats why we need to look for the payload there

      if (this.collectionDrag) {
        payload = this.collectionDrag[index]
        payload.collectionDrag = this.collectionDrag
      }

      if (this.collectionByTab && this.showTabs) {
        if (!Object.keys(payload).length) {
          payload = this.collectionByTab[index]
        }
        payload.isInTab         = true
        payload.collectionByTab = this.collectionByTab
      } else {
        if (!Object.keys(payload).length) {
          payload = this.collection[index]
        }
      }

      payload.collectionIdx   = this.collection.indexOf(payload)
      payload.collection      = this.collection

      if (this.shouldRemoveOnDrop || payload.shouldBeDeleted) {
        payload.shouldBeDeleted = true
      }

      return payload
    },
    onDrop(dropResult) {
      this.$emit('onDrop', dropResult)
    },
    getShouldAcceptDrop(sourceContainerOptions, payload) {
      return this.shouldAcceptDrops
    }
  }
}
</script>
<style lang="sass" scoped>
.drag-container
  margin-bottom: 30px

</style>
<style lang="sass">
.drag-dragging
  border: 2px solid $ink-lighter !important
  border-radius: 5px !important

.drag-dragging-options
  border-top: 1px solid $paper !important
  cursor: grabbing

.drag-ghost
  border: 2px dashed $sensual
  background-color: $sensual-lighter
  border-radius: 5px
  margin: 0px 0px 15px 0px

.drag-ghost-options
  background-color: $sensual-lighter
  margin: 0px 0px 15px 0px

</style>



// WEBPACK FOOTER //
// DragContainer.vue?3eb1ffac